<footer class="rahma-footer">
  <div class="footer-content">
    <span class="footer-text">
      © {{ currentYear }} {{ 'FOOTER.APP_NAME' | translate }} - {{ 'FOOTER.RIGHTS' | translate }}
    </span>
    <span class="footer-version">
      v{{ appVersion }}
    </span>
    <div class="footer-devwise">
      <img src="/assets/img/devwise_logo-removebg-preview.png" alt="Devwise Logo" class="devwise-logo" />
      <span class="devwise-text">{{ 'SIDEBAR.POWERED_BY' | translate }}</span>
    </div>
  </div>
</footer>
